import { ControllerRenderProps, UseFormRegister } from "react-hook-form"
import { CityPublic } from "../../client"
import { Combobox, HStack, Portal, Span, Spinner, useListCollection } from "@chakra-ui/react"

interface PostcodeFieldProps {
  collection: ReturnType<typeof useListCollection<CityPublic>>["collection"]
  loading: boolean
  field: ControllerRenderProps<any, string>,
  onInputChange: (postcode: string) => void
  onValueChange: (value: string) => void
  register: UseFormRegister<any>
  isRequired: boolean
}

const PostcodeField =({
  collection,
  loading,
  field,
  onInputChange,
  onValueChange,
  register,
  isRequired
}: PostcodeFieldProps) => {
    const valueChanged = (e: string) => {
        onValueChange(e)

        if(e) {
            const postcode = e.split(" -")[0]
            field.onChange(postcode)
        } else {
            field.onChange(e || "")
        }
    }

    return (
        <Combobox.Root
            collection={collection}
            allowCustomValue={true}
            openOnClick={collection.items.length > 0 ? true : false}
            onValueChange={({ value }) => { valueChanged(value[0])}}
            onInputValueChange={(e) => onInputChange(e.inputValue)}
        >
            <Combobox.Control>
            <Combobox.Input 
                placeholder="PLZ eingeben"
                {...register(field.name, {
                    required: isRequired ? "PLZ wird benötigt" : false,
                    maxLength: {
                        value: 4,
                        message: "PLZ darf maximal 4 Zeichen lang sein",
                    },
                    minLength: {
                        value: 4,
                        message: "PLZ muss mindestens 4 Zeichen lang sein",  
                    },
                })}
                onChange={(e) => field.onChange(e.target.value)}
            />
            <Combobox.IndicatorGroup>
                <Combobox.ClearTrigger />
                <Combobox.Trigger />
            </Combobox.IndicatorGroup>
            </Combobox.Control>

            <Portal>
                <Combobox.Positioner zIndex="10000 !important">
                    <Combobox.Content>
                        {loading ? (
                            <HStack p="2">
                                <Spinner size="xs" borderWidth="1px" />
                                <Span>Laden...</Span>
                            </HStack>
                        ) : (
                            collection.items.map((item, i) => (
                                <Combobox.Item key={i} item={item}>
                                    {item.postcode} - {item.name}
                                    <Combobox.ItemIndicator />
                                </Combobox.Item>
                            ))
                        )}
                    </Combobox.Content>
                </Combobox.Positioner>
            </Portal>
        </Combobox.Root>
    )
}

export default PostcodeField
